import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import FiltroClientesGestionar from "../../GestionCobranza/Components/FiltroClientesGestionar";
import FiltroClientesJuridico from "./FiltroClientesJuridicoCobranza";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { TimelineModal } from "../Modales/TimelineModal";
import CommentIcon from '@mui/icons-material/Comment';
import FiltroClientesJuridicoCobranzaDash from "./FiltroClientesJuridicoCobranzaDash";

export const ContextConvenio = createContext();
export const ListadoClientesJuridicosScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const permisos = location.state?.permisos;
    const [selected, setSelected] = useState([]);
    const [predictivo, setPredictivo] = useState("");
    const [clientes, setClientes] = useState([]);
    const [arrayClientes, setArrayClientes] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const storedState = JSON.parse(localStorage.getItem('state')) || {};
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [openModal, setOpenModal] = useState(false);
    const [selectedCliente, setSelectedCliente] = useState();

    const [stateFiltro, setStateFiltro] = useState({
        ejercicio: storedState.ejercicio || boxstate.ejercicio,
        adr: (storedState.adr ? storedState.adr.filter(item => item.checked).map(({ idadr, adr }) => ({ idadr, adr })) : boxstate.pv.adr),
        sucursal: (storedState.sucursal ? storedState.sucursal.filter(item => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal })) : boxstate.pv.sucursal)
    });

    const handleOpenModal = (idcliente, comentario) => {
        // console.log(comentario)
        if (comentario === 'Si') {
            setSelectedCliente(idcliente);
            setOpenModal(true);
        }
    };

    const handleClose = () => {
        setOpenModal(false);
        setSelectedCliente('');
    };

    useEffect(() => {
        setStateFiltro({
            ejercicio: storedState.ejercicio || boxstate.ejercicio,
            adr: boxstate.pv.adr,
            sucursal: boxstate.pv.sucursal
        });
    }, [boxstate]);

    // console.log(GetKey(stateFiltro.adr, ["idadr"]))

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
        var adr = GetKey(stateFiltro.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = GetKey(permisos, ["idsucursal"]) || "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        request
            .get(`ClientesEnviarJuridico/Listado?sucursal=${sucursales}&adr=${adr}&estatus=${"O"}`)
            .then((result) => {
                setClientes(result);
                setArrayClientes(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, []);

    const onExecute = (estatus) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        // console.log(adr, sucursales)
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ClientesEnviarJuridico/Listado?sucursal=${sucursales}&adr=${adr}&estatus=${estatus}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    setArrayClientes(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    useEffect(() => {
        const result = arrayClientes.filter((item) =>
            item.razon_social.toUpperCase().includes(predictivo.toUpperCase())
        );
        setSelected([]);
        setClientes(result);
    }, [predictivo]);

    const onRegistrar = (idcliente, razonsocial) => {
        history.push("/Creditoycobranza/RegistrarCliente", {
            idcliente,
            razonsocial,
        });
    };
    const onConvenio = (idcliente, razonsocial, responsable, estatus) => {

        if (idcliente.toString().length <= 6) {
            history.push("/Creditoycobranza/DetalleClientesGestionarJuridico", {
                idcliente,
                razonsocial,
                responsable,
                estatus
            });
        } else {
            Swal.fire("CREDITO Y COBRANZA", "El cliente no se encuentra registrado", "error");
        }
    };
    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const onGeneraExcel = (responsable, linea, cartera, convenio, juridico) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = GetKey(permisos, ["idsucursal"]) || "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoClientesGestionarPrueba/ImprimirExcel?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };
    // console.log(boxstate)

    const onGeneraPDF = (responsable, linea, cartera, convenio, juridico) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = GetKey(permisos, ["idsucursal"]) || "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoClientesGestionarPrueba/ImprimirPDF?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onEstatus = (estatus) => {
        if (estatus === "Revisión") {
            return "info-estatus-circulo circulo-azul"
        }
        else if (estatus === "Cobranza") {
            return "info-estatus-circulo circulo-amarillo"
        }
        else if (estatus === "Juridico") {
            return "info-estatus-circulo circulo-rojo"
        }
        else if (estatus === "Finalizado") {
            return "info-estatus-circulo circulo-verde"
        }
        else {
            return "info-estatus-circulo circulo-gris"
        }
    }

    const onClickEstatus = (estatus) => {
        onExecute(estatus);
    }

    // console.log(clientes)

    return (
        <PlantillaScreen
            titulo={"SELECCIONAR CLIENTE A GESTIONAR"}
            className={"listado-clientes-gestionar-main-screen"}
            className_main={1}
        >
            <div className="listado-clientes-gestionar-actions">
                <div
                    className="listado-clientes-gestionar-actions-regresar"
                    onClick={() => history.push('/Creditoycobranza/DashboardCobranza')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="listado-clientes-gestionar-actions-filtro">
                    <FiltroClientesJuridicoCobranzaDash
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        sucursales={permisos}
                    />
                </div>
                {/* <div className="buttons">
                    <button className="excel"
                        onClick={() => onGeneraExcel(boxstate.responsable, boxstate.linea, boxstate.cartera, boxstate.convenio, boxstate.juridico)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(boxstate.responsable, boxstate.linea, boxstate.cartera, boxstate.convenio, boxstate.juridico)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div> */}
            </div>
            <div className="listado-clientes-juridico-info-container">
                <div></div>
                <div className="">
                    Clientes Encontrados: {clientes.length}
                </div>
            </div>

            <LoaderScreen loader={loader} />
            <div className="listado-clientes-gestionar-screen">
                <div className="listado-clientes-gestionar-header">
                    <div className="listado-clientes-gestionar-header-control">
                        <TextField
                            color="success"
                            fullWidth
                            size="small"
                            value={predictivo}
                            onChange={({ target }) => setPredictivo(target.value)}
                            placeholder="Buscar Clientes..."
                        />
                    </div>
                </div>
                <div className="listado-clientes-enviar-juridico-container scroll-4">
                    {clientes !== undefined &&
                        clientes !== null &&
                        clientes.length > 0 ? (
                        <table cellSpacing={0} cellPadding={0}>
                            <thead>
                                <tr>
                                    <th className="celda-circulo"></th>
                                    <th>

                                    </th>
                                    <th className="razon-social-celda">
                                        <div>Cliente</div>
                                    </th>
                                    <th>
                                        <div>Vencimiento</div>
                                    </th>
                                    <th>
                                        <div>Días Vencidos</div>
                                    </th>
                                    <th>
                                        <div>Saldo Vencido</div>
                                    </th>
                                    <th>
                                        <div>Saldo por Vencer</div>
                                    </th>
                                    <th>
                                        <div>Saldo Total</div>
                                    </th>
                                    <th>
                                        <div>Recuperado</div>
                                    </th>
                                    <th>
                                        <div>Recuperación</div>
                                    </th>
                                    <th>
                                        <div>Estatus</div>
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {clientes.map((ctl) => (
                                    <tr onClick={() =>
                                        onConvenio(ctl.idcliente, ctl.razon_social, ctl.idResponsableCobranza, ctl.estatus)
                                    }>
                                        {/* <td className="id-cliente-celda">
                                            {ctl.idcliente}
                                        </td> */}
                                        <td className="celda-circulo">
                                            <div className={onEstatus(ctl.estatus)}></div>
                                        </td>
                                        <td className="celda-button">
                                            <div className={ctl.tiene_comentario === "Si" ? "img" : "img-sin-color"} onClick={(event) => {
                                                event.stopPropagation(); // Evita que el evento se propague al <tr>
                                                handleOpenModal(ctl.idcliente, ctl.tiene_comentario);
                                            }}><CommentIcon /></div></td>
                                        {/* <td className='celda-button'>
                                            <div className="timeline-button"
                                                onClick={(event) => {
                                                    event.stopPropagation(); // Evita que el evento se propague al <tr>
                                                    handleOpenModal(ctl.idcliente);
                                                }}
                                                style={{ cursor: "pointer" }}>
                                                <CommentIcon />
                                                
                                            </div>
                                        </td> */}
                                        <td className="razon-social-celda">{capitalizeWords(ctl.razon_social)}</td>
                                        <td className="vencimiento-celda">{ctl.vencimiento}</td>
                                        <td className="fecha-celda">{ctl.dias_vencidos}</td>
                                        <td className="saldo-celda">{ctl.saldo_vencido === 0 ? '-' : FormatMoney(ctl.saldo_vencido, 0)}</td>
                                        <td className="saldo-celda">{ctl.saldo_porvencer === 0 ? '-' : FormatMoney(ctl.saldo_porvencer, 0)}</td>
                                        <td className="saldo-celda">{ctl.saldo_total === 0 ? '-' : FormatMoney(ctl.saldo_total, 0)}</td>
                                        <td className="saldo-celda">{ctl.recuperado === 0 ? '-' : FormatMoney(ctl.recuperado, 0)}</td>
                                        <td className="fecha-celda">{ctl.fecha_recuperacion}</td>
                                        <td className="convenio-celda">{capitalizeWords(ctl.estatus)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div>Sin Datos</div>
                    )}
                    <div>
                        <table></table>
                    </div>
                </div>
                <div className="listado-clientes-enviar-juridico-info-container">
                    <div className="info-estatus">
                        <div className="info-estatus blanco" onClick={() => onClickEstatus('O')}>
                            <div className="info-estatus-circulo circulo-consolidado"></div>
                            Consolidado
                        </div>

                        <div className="info-estatus blanco" onClick={() => onClickEstatus('P')}>
                            <div className="info-estatus-circulo circulo-gris"></div>
                            Pendiente
                        </div>

                        <div className="info-estatus green" onClick={() => onClickEstatus('R')}>
                            <div className="info-estatus-circulo circulo-azul"></div>
                            Revisión
                        </div>


                        <div className="info-estatus green" onClick={() => onClickEstatus('C')}>
                            <div className="info-estatus-circulo circulo-amarillo"></div>
                            Cobranza
                        </div>

                        <div className="info-estatus green" onClick={() => onClickEstatus('J')}>
                            <div className="info-estatus-circulo circulo-rojo"></div>
                            Juridico
                        </div>
                        <div className="info-estatus green" onClick={() => onClickEstatus('F')}>
                            <div className="info-estatus-circulo circulo-verde"></div>
                            Finalizado
                        </div>
                    </div>
                    <div></div>
                </div>
                <TimelineModal
                    open={openModal}
                    handleClose={handleClose}
                    idcliente={selectedCliente}
                />
            </div>
        </PlantillaScreen>
    );
};
